(function () {
  var deadline = new Date("2026-07-10T17:00:00-05:00").getTime();

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function updateCountdown() {
    var timer = document.querySelector("[data-ybv9-countdown]");
    if (!timer) return;
    var diff = Math.max(0, deadline - Date.now());
    var values = {
      days: Math.floor(diff / 86400000),
      hours: Math.floor((diff % 86400000) / 3600000),
      minutes: Math.floor((diff % 3600000) / 60000),
      seconds: Math.floor((diff % 60000) / 1000)
    };
    Object.keys(values).forEach(function (key) {
      var node = timer.querySelector("[data-ybv9-" + key + "]");
      if (node) node.textContent = pad(values[key]);
    });
  }

  function setupGallery() {
    var main = document.querySelector("[data-ybv9-gallery-main]");
    var thumbs = Array.prototype.slice.call(document.querySelectorAll("[data-ybv9-gallery-thumbs] .ybv9-offer-thumb"));
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-full");
        if (src) main.src = src;
        thumbs.forEach(function (item) { item.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  function setupQuantityCards() {
    var cards = Array.prototype.slice.call(document.querySelectorAll("[data-ybv9-qty-card]"));
    if (!cards.length) return;

    function select(card) {
      var scrollX = window.scrollX;
      var scrollY = window.scrollY;
      cards.forEach(function (item) { item.classList.remove("is-selected"); });
      card.classList.add("is-selected");
      var input = card.querySelector('input[type="radio"]');
      if (input) input.checked = true;
      window.requestAnimationFrame(function () {
        window.scrollTo(scrollX, scrollY);
      });
    }

    cards.forEach(function (card) {
      card.addEventListener("click", function (event) {
        if (event.target.tagName !== "INPUT") event.preventDefault();
        select(card);
      });
    });
  }

  function parseVariantIds(value) {
    return String(value || "")
      .split(",")
      .map(function (item) { return item.trim(); })
      .filter(function (item) { return /^\d+$/.test(item); });
  }

  function parseDiscountCodes(value) {
    return String(value || "")
      .split(",")
      .map(function (item) { return item.trim(); })
      .filter(function (item) { return /^[A-Za-z0-9_-]+$/.test(item); });
  }

  function setupBonusCartForms() {
    var forms = Array.prototype.slice.call(document.querySelectorAll(".ybv9-offer-form"));
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener("submit", function (event) {
        if (form.getAttribute("data-ybv9-submitting") === "true") return;
        var selectedInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
        var selectedCard = selectedInput ? selectedInput.closest("[data-ybv9-qty-card]") : null;
        var plannerId = selectedInput ? selectedInput.value : "";
        var bonusIds = selectedCard ? parseVariantIds(selectedCard.getAttribute("data-ybv9-bonus-variants")) : [];
        var discountCodes = selectedCard ? parseDiscountCodes(selectedCard.getAttribute("data-ybv9-discount-codes")) : [];
        if (!/^\d+$/.test(plannerId) || !bonusIds.length || !discountCodes.length) return;

        event.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        if (button) {
          button.disabled = true;
          button.setAttribute("aria-busy", "true");
        }
        form.setAttribute("data-ybv9-submitting", "true");

        var itemPath = bonusIds.slice().reverse().map(function (id) {
          return encodeURIComponent(id) + ":1";
        }).concat([encodeURIComponent(plannerId) + ":1"]).join(",");
        var discounts = discountCodes.map(function (code) {
          return encodeURIComponent(code);
        }).join(",");

        window.location.href = "/cart/" + itemPath + "?discount=" + discounts;
      });
    });
  }

  function setupFaqs() {
    var faq = document.querySelector("[data-ybv9-faq]");
    if (!faq) return;
    faq.addEventListener("click", function (event) {
      var button = event.target.closest(".ybv9-faq-q");
      if (!button) return;
      var item = button.closest(".ybv9-faq-item");
      var isOpen = item.classList.toggle("is-open");
      button.setAttribute("aria-expanded", String(isOpen));
      var icon = button.querySelector("span:last-child");
      if (icon) icon.textContent = isOpen ? "-" : "+";
    });
  }

  function setupReveals() {
    var items = Array.prototype.slice.call(document.querySelectorAll(".ybv9-reveal"));
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (item) { item.classList.add("is-visible"); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    items.forEach(function (item) { observer.observe(item); });
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
  setupGallery();
  setupQuantityCards();
  setupBonusCartForms();
  setupFaqs();
  setupReveals();
})();
